import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

const CalendarRedirectPage = (): JSX.Element => <Navigate to="/feed" />;

export const Route = createFileRoute("/_app/calendar/")({
	component: CalendarRedirectPage,
});
